export const NO_BLANKS = "__no_blanks";